import React from "react";
import { MapControl, ControlPosition } from "@vis.gl/react-google-maps";
import { AddressAutocomplete } from "./AddressAutocomplete";
import { Stack } from "@mui/system";

const AddressLookupControl = () => {
    return (
        <MapControl position={ControlPosition.TOP_CENTER}>
            <Stack
                sx={{
                    margin: "24px",
                    background: "#fff"
                }}
            >
                <AddressAutocomplete />
            </Stack>
        </MapControl>
    );
};

export { AddressLookupControl };
